function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M19.317 17.986h-1.118v-7.034a8.864 8.864 0 00-5.851-8.54 2.35 2.35 0 10-4.7 0 8.864 8.864 0 00-5.851 8.54v7.034H.683a.683.683 0 100 1.365h6.8a.68.68 0 00-.043.232 2.568 2.568 0 105.124 0 .673.673 0 00-.043-.232h6.8a.683.683 0 100-1.365zM10 1.366a1 1 0 01.918.73 7.4 7.4 0 00-1.836 0 1 1 0 01.918-.73zm-6.834 9.587c0-4.162 3.066-7.549 6.834-7.549s6.834 3.386 6.834 7.549v7.034H3.166zm8.03 8.631a1.208 1.208 0 11-2.393 0 .68.68 0 00-.043-.232h2.479a.673.673 0 00-.043.232z"
});

function SvgIconAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 22.324"
  }, props), _ref);
}

export default SvgIconAlert;